import React from 'react';
import { FaCog } from 'react-icons/fa';

const AdminSettings = () => {
  return (
    <div className="p-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Settings</h1>
        <p className="text-gray-600">Configure system settings</p>
      </div>
      
      <div className="bg-white rounded-lg shadow p-12 text-center">
        <FaCog className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">Settings</h3>
        <p className="mt-1 text-sm text-gray-500">Settings functionality coming soon.</p>
      </div>
    </div>
  );
};

export default AdminSettings; 